"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xorBy = exports.xor = void 0;
const EnumerableFactory_1 = require("../utilities/EnumerableFactory");
const applyXor_1 = require("./applicators/applyXor");
function xor(src, ...second) {
    return (0, applyXor_1.applyXor)(new EnumerableFactory_1.EnumerableFactory(), (x) => x, src, second);
}
exports.xor = xor;
function xorBy(src, ...second) {
    return (0, applyXor_1.applyXor)(new EnumerableFactory_1.EnumerableFactory(), null, src, second);
}
exports.xorBy = xorBy;
//# sourceMappingURL=xor.js.map